module.exports = __webpack_public_path__ + "static/media/img_0.1c64c2cd.png";